import Image from '@/components/Image';
import { mediaBreakpointUp, square } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC } from 'react';
import styled from 'styled-components';

export interface FeatureTileProps {
  text: string;
  icon: {
    src: string;
  };
}

const FeatureTile: FC<FeatureTileProps> = ({ text, icon }) => {
  return (
    <FeatureItem>
      <FeatureIconWrapper iconSrc={icon.src}>
        <Image src={icon.src} alt={text} height={60} width={60} />
      </FeatureIconWrapper>
      <FeatureName>{text}</FeatureName>
    </FeatureItem>
  );
};

export default FeatureTile;

// Styled Components
const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${remCalc(20)};
`;

const FeatureIconWrapper = styled.div<{ iconSrc: string }>`
  ${square(40)}

  ${mediaBreakpointUp('tablet')} {
    ${square(60)}
  }
`;

const FeatureName = styled.span`
  text-align: center;
  ${customTextSize(16, 21)};
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(20, 24)};
  }
`;
